export default __webpack_public_path__ + "static/media/ltr-qt-img.ab846a1d.webp";